class BenefitBonagoController {}
BenefitBonagoController.$inject = [];
angular
  .module('VSPApp')
  .controller('BenefitBonagoController', BenefitBonagoController);
